const searchfiltersActions = (function ($) {
  function setWrapperValue(wrapper, value, unit) {
    if (wrapper) {
      wrapper.html(value + ' ' + unit);
    }
  }

  $('.searchfilter-range input[type="range"]').on('input', function() {
    setWrapperValue($('#' + $(this).attr('id') + '_value'), $(this).val(), $(this).attr('data-unit'));
  });

  $('.searchfilter-range input[type="range"]').each(function () {
    setWrapperValue($('#' + $(this).attr('id') + '_value'), $(this).val(), $(this).attr('data-unit'));
  });
})(window.jQuery);
